import React, { useContext, useEffect, useState } from 'react'
import ViewContext from '../../context/ViewContext';
import { Stepper } from 'react-form-stepper';
import '../../Styles/Header.css'

function Header() {
    const [active, setActive] = useState(0);
    const [dataView,] = useContext(ViewContext);

    useEffect(() => {
        switch (dataView) {
            case 'DP':
                setTimeout(()=>{
                },500)
                setActive(0);                    
                break;
            case 'LZ':
                setTimeout(()=>{
                },500)
                setActive(1);                    
                break;
            case 'SMS':
                setTimeout(()=>{
                },500)
                setActive(2);                    
                break;
            default:
                break;
        }
    }, [dataView])



    return (
        <>
            <div className='stepper_new'>
                <div className='stepContainer'>
                    <label className={`stepper_title active_Text1`}>Datos Personales</label>
                    <div className={`stepper_circle active_Circle1`}></div>
                    <div className={`stepper_bar ${active == 1 || active == 2? 'active_Barline1' : 'disabled_Barline'}`}></div>
                </div>
                <div className='stepContainer'>
                    <label className={`stepper_title ${active == 1 || active == 2 ? 'active_Text2' : 'disabled_Text'}`}>Localización</label>
                    <div className={`stepper_circle ${active == 1 || active == 2 ? 'active_Circle2' :'disabled_Circle'}`}></div>
                    <div className={`stepper_bar ${active == 2 ? 'active_Barline2' : 'disabled_Barline'}`}></div>
                </div> 
                <div className='stepContainer'>
                    <label className={`stepper_title ${active == 2 ? 'active_Text3' : 'disabled_Text'}`}>Verificación Telefónica</label>
                    <div className={`stepper_circle ${active == 2 ? 'active_Circle3' :'disabled_Circle'}`}></div>
                    {/* <div className='stepper_circle '></div> */}
                </div>  
            </div>
            {/* <Stepper
                steps={[{
                    label: 'Datos Personales 1'
                }, { label: 'Localización' }, { label: 'Verificación' }]}
                activeStep={active}
            /> */}
        </>
    );
}


export default Header;

